module.exports = __webpack_public_path__ + "img/crown-big-icon.6940857d.svg";